import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/sites/$siteSlug/content-types/tables')({
  component: TablesLayout,
});

function TablesLayout() {
  return <Outlet />;
}
